import { Link } from "react-router-dom";
import FadeInSection from "./FadeInSection";

export default function SeriesNavigation({ items, currentSlug, basePath }) {
  const currentIndex = items.findIndex(item => item.slug === currentSlug);
  const nextIndex = (currentIndex + 1) % items.length;
  const nextItem = items[nextIndex];

  return (
    <div className="mt-4 md:mt-16 pt-[5rem] flex justify-end overflow-hidden pb-[8rem] md:pb-[4rem]">
      <FadeInSection direction="right">
        <Link
          to={`${basePath}/${nextItem.slug}`}
          className="inline-flex items-center gap-4 hover:opacity-80 transition-opacity group"
        >
          <div className="flex flex-col items-end">
            <div className="font-thin text-right text-[1.8rem] md:text-[1.7rem] leading-[2rem]">Continue to</div>
            <div className="text-right">
              <div className="font-syne text-[#C3EEFD] text-[2.8rem] md:text-[2.6rem] md:text-[2.8rem] leading-[3.2rem] tracking-[.08rem] group-hover:text-primary-red transition-colors font-bold">
                {nextItem.name}
              </div>
              <span className="text-[2rem] leading-[2.5rem]">
                {nextItem.category}
              </span>
            </div>
          </div>
          <div className="w-32 h-[2px] bg-primary-red group-hover:bg-white transition-colors"></div>
        </Link>
      </FadeInSection>
    </div>
  );
}
